// API client for the Swing Analyzer worker.
// All requests go through /api/* which is proxied to the worker in dev
// and served from the same origin in production (Pages + Worker route).

const JSON_HEADERS = { 'Content-Type': 'application/json' };

async function req(path, opts = {}) {
  const res = await fetch(path, opts);
  if (!res.ok) {
    let msg = `${res.status} ${res.statusText}`;
    try { const j = await res.json(); if (j.error) msg = j.error; } catch {}
    throw new Error(msg);
  }
  if (res.status === 204) return null;
  return res.json();
}

export const api = {
  me: () => req('/api/me'),

  // Videos
  listVideos: () => req('/api/videos').then(r => r.videos),
  uploadVideo: async (file, meta = {}, onProgress) => {
    // Use XHR for upload progress
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', '/api/videos');
      xhr.setRequestHeader('Content-Type', file.type || 'video/mp4');
      xhr.setRequestHeader('X-Filename', encodeURIComponent(file.name));
      if (meta.label) xhr.setRequestHeader('X-Label', meta.label);
      if (meta.club) xhr.setRequestHeader('X-Club', meta.club);
      if (meta.view_angle) xhr.setRequestHeader('X-View-Angle', meta.view_angle);
      if (meta.duration) xhr.setRequestHeader('X-Duration', String(meta.duration));
      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable && onProgress) onProgress(e.loaded / e.total);
      };
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(JSON.parse(xhr.responseText));
        } else {
          try {
            reject(new Error(JSON.parse(xhr.responseText).error || xhr.statusText));
          } catch {
            reject(new Error(xhr.statusText));
          }
        }
      };
      xhr.onerror = () => reject(new Error('Network error'));
      xhr.send(file);
    });
  },
  updateVideo: (id, patch) => req(`/api/videos/${id}`, {
    method: 'PATCH', headers: JSON_HEADERS, body: JSON.stringify(patch)
  }),
  deleteVideo: (id) => req(`/api/videos/${id}`, { method: 'DELETE' }),

  // Streaming URL
  streamUrl: (r2_key) => `/api/stream/${encodeURIComponent(r2_key)}`,

  // Sessions
  listSessions: () => req('/api/sessions').then(r => r.sessions),
  getSession: (id) => req(`/api/sessions/${id}`).then(r => r.session),
  saveSession: (session) => req('/api/sessions', {
    method: 'POST', headers: JSON_HEADERS, body: JSON.stringify(session)
  }),
  deleteSession: (id) => req(`/api/sessions/${id}`, { method: 'DELETE' }),

  // Pros
  listPros: () => req('/api/pros').then(r => r.pros),
  uploadPro: async (file, meta = {}, onProgress) => {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', '/api/pros');
      xhr.setRequestHeader('Content-Type', file.type || 'video/mp4');
      xhr.setRequestHeader('X-Filename', encodeURIComponent(file.name));
      xhr.setRequestHeader('X-Player-Name', meta.player_name || '');
      xhr.setRequestHeader('X-Club', meta.club || '');
      xhr.setRequestHeader('X-View-Angle', meta.view_angle || '');
      xhr.setRequestHeader('X-Notes', meta.notes || '');
      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable && onProgress) onProgress(e.loaded / e.total);
      };
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) resolve(JSON.parse(xhr.responseText));
        else reject(new Error(xhr.statusText));
      };
      xhr.onerror = () => reject(new Error('Network error'));
      xhr.send(file);
    });
  },
  deletePro: (id) => req(`/api/pros/${id}`, { method: 'DELETE' })
};
